import React, {Fragment, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {useDispatch, useSelector} from 'react-redux';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {SurveysGoal} from 'client/common/types';
import Header, {headerMeaningfulSelector} from 'client/common/components/header2';
import Modal from 'client/common/components/modal';
import Notifications from 'client/common/components/notifications';

import {useCurrentOrg} from 'client/common/hooks/orgs';
import history from 'client/common/utils/history';
import {createUrl} from 'client/common/utils/history';
import {useRumCounter} from 'client/common/utils/rum';

import {getTestBuckets} from 'client/common/store/selectors/user';
import {sendGoals} from 'client/common/store/actions/metrika';

import SurveyCreator from 'client/quicksurvey/survey-create/components/survey-creator';

import {ComponentProps} from './types';

import './create.css';

const i18n = I18N.surveyCreate;
const b = b_.with('create-page');

function Creator({testBuckets}: ComponentProps) {
    const dispatch = useDispatch();
    const org = useCurrentOrg();

    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            if (location.pathname.replace(/\/$/, '') === '/quicksurvey' && action === 'POP') {
                dispatch(sendGoals([SurveysGoal.MoveBackToCreate]));
                unlisten();
            }
        });
    }, [dispatch]);

    useRumCounter({
        page: 'quicksurvey.create',
        meaningfulPaintSelector: headerMeaningfulSelector,
        testBuckets
    });

    const handleClickClose = () => {
        history.push(
            createUrl({link: '/quicksurvey/list', relative: true, extraSearchParams: {org}})
        );
    };

    return (
        <div className={b()}>
            <div className={b('creator-wrapper')}>
                <SurveyCreator />
                <a className={b('close-button')} onClick={handleClickClose} />
            </div>
        </div>
    );
}

export default function CreatePage() {
    const testBuckets = useSelector(getTestBuckets);

    return (
        <Fragment>
            <Helmet>
                <title>{i18n.pageTitle}</title>
                <meta property='og:url' content='https://surveys.yandex.ru/quicksurvey' />
            </Helmet>
            <Header className={b('header')} />
            <Creator testBuckets={testBuckets} />
            <Notifications />
            <Modal />
        </Fragment>
    );
}
